import React from 'react';
import PropTypes from 'prop-types';
import { Buy4Pay3 } from './product/buy_4_pay_3';
import { Cashback100 } from './product/cashback_100';
import { SetPriceRow } from './product/set_price_row';
import { featureFlags } from '../../../../_constants/feature_flags';

export function ProductSetPrice(props) {
    const { buy4pay3, cashback100 } = props;
    const hasDiscount = featureFlags.FEATURE_TYRE_DEALS && cashback100;
    const hasBuy4Pay3 = featureFlags.FEATURE_TYRE_DEALS && buy4pay3;
    const discountPrice = (props.quantity * props.pricePerItem) - props.setPrice;
    const productSetPriceRows = [];

    productSetPriceRows.push(
        <SetPriceRow
            quantity={props.quantity}
            pricePerItem={props.pricePerItem}
            isMpsProduct={props.isMpsProduct}
            currencyIsoCode={props.currencyIsoCode}
            hasPaddingBottom={!hasDiscount}
            hasBuy4Pay3={hasBuy4Pay3}
            discountPrice={discountPrice}
            hideLabel={props.hideLabel}
            noBottomPadding={props.noBottomPadding}
            className={props.className}
            key="ProductSetPriceRow"
        />,
    );

    if (featureFlags.FEATURE_TYRE_DEALS && cashback100) {
        productSetPriceRows.push(
            <Cashback100
                discount={discountPrice}
                currencyIsoCode={props.currencyIsoCode}
                key="Cashback100"
            />
        );
    }

    return productSetPriceRows;
}

ProductSetPrice.propTypes = {
    buy4pay3: PropTypes.bool.isRequired,
    cashback100: PropTypes.bool.isRequired,
    quantity: PropTypes.number.isRequired,
    pricePerItem: PropTypes.number.isRequired,
    setPrice: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    isMpsProduct: PropTypes.bool,
};

ProductSetPrice.defaultProps = {
    isMpsProduct: false,
};
